import { render, staticRenderFns } from "./report_item.vue?vue&type=template&id=46c84fd5&"
import script from "./report_item.vue?vue&type=script&lang=js&"
export * from "./report_item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "report_item.vue"
export default component.exports